import auth from '@client/components/auth';

export const resolveInfluencerId = (
  influencerId?: string | number,
): number | null => {
  const raw: string | number | null | undefined =
    influencerId ?? auth.getUser()?.influencerId;
  if (raw === null || raw === undefined) return null;
  const id = Number(raw);
  return Number.isFinite(id) && id > 0 ? id : null;
};
